/* eslint-disable no-param-reassign */
import produce from 'immer';

import { INTL_LANG } from '../actions/intlAction';

const initialState = {
  intl: null
};

const intlReducer = (state = initialState, action) => {
  switch (action.type) {
    case INTL_LANG: {
      const { intl } = action.payload;
      return produce(state, (draft) => {
        draft.intl = intl;
      });
    }

    default: {
      return state;
    }
  }
};

export default intlReducer;
